import { useEffect, useState } from "react";
import { ordersAnalyticsApi } from "@/features/orders-analytics/api/orders-analytics.api";
import {
    CustomerIntelligenceResponse,
    OrdersAnalyticsFilters,
} from "@/features/orders-analytics/types/orders-analytics.types";

export function useCustomerIntelligenceData(filters: OrdersAnalyticsFilters) {
    const [customerIntelligence, setCustomerIntelligence] = useState<CustomerIntelligenceResponse | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);

        ordersAnalyticsApi
            .fetchCustomerIntelligence(filters)
            .then((response) => {
                if (!cancelled) {
                    setCustomerIntelligence(response);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setCustomerIntelligence(null);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [filters]);

    return { customerIntelligence, loading };
}
